import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_APP016_Request,
  IAPI_APP016_Response,
  IAPI_REC008_Request,
  IAPI_REC008_Response,
} from "../../../type/apiType";
import {
  IAPI_REC028_Request,
  IAPI_REC028_Response,
} from "../../../type/apiType";
import { IAPI_REC027_Response } from "../../../type/apiType";

// 都道府県補助金要処理参照API
const httpAPI_REC028 = async (
  param: IAPI_REC028_Request
): Promise<IAPI_REC028_Response> => {
  let res = await http.post(ApiUrl.API_REC028, {
    ...param,
  });

  return res.data;
};

// 都道府県補助金額参照API
const httpAPI_REC027 = async (): Promise<IAPI_REC027_Response> => {
  let res = await http.post(ApiUrl.API_REC027, {});

  return res.data;
};

// 請求状況更新
const httpAPI_REC008 = async (
  param: IAPI_REC008_Request
): Promise<IAPI_REC008_Response> => {
  let res = await http.post(ApiUrl.API_REC008, {
    ...param,
  });

  return res.data;
};

// 請求状況更新
const httpAPI_APP016 = async (
  param: IAPI_APP016_Request
): Promise<IAPI_APP016_Response> => {
  let res = await http.post(ApiUrl.API_APP016, {
    ...param,
  });

  return res.data;
};

export { httpAPI_REC008, httpAPI_REC028, httpAPI_REC027, httpAPI_APP016 };
